// extracted by mini-css-extract-plugin
module.exports = {"title":"IntroLargeTitle-module--title--1u7gB"};